import { render } from "./SearchCollaborationFilter.vue?vue&type=template&id=2c7f9b0e"
import script from "./SearchCollaborationFilter.vue?vue&type=script&lang=js"
export * from "./SearchCollaborationFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__